import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const TARIFFSMODULE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TariffsModule.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.TariffsModule.Code')
    .required()
    .minLength(2)
    .maxLength(25)
    .build(),
];

export const TARIFFSMODULE_CONFIG = {
  entityName: 'TariffsModule',
  localizationKey: 'Controlling::Entity.TariffsModule',
  fields: TARIFFSMODULE_FIELDS,
  permission: 'ControllingLiquidations.TariffsModules',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
